import { j as t } from "../jsx-runtime-Wav_3Wde.js";
import { s } from "../index.esm-DOxVcNnO.js";
import { styled as n } from "styled-components";
import { space as f } from "styled-system";
import "../Icon/StyledPath.mjs";
import h from "../Icon/Icons/NewTabIcon.mjs";
import "../colors-C72eWVhK.js";
import { SCREEN_WIDTHS as g } from "../common/themes/constants/constants.mjs";
import w from "../typography/Link/Link.mjs";
import I from "../typography/Paragraph/Paragraph.mjs";
import u from "../typography/VisuallyHidden/VisuallyHidden.mjs";
const C = /* @__PURE__ */ n.footer.withConfig({
  shouldForwardProp: (o) => s(o)
}).withConfig({
  componentId: "sc-67378247-0"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.footer.wrapper, f), x = /* @__PURE__ */ n.div.withConfig({
  shouldForwardProp: (o) => s(o)
}).withConfig({
  componentId: "sc-67378247-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.footer.content), k = /* @__PURE__ */ n.ul.withConfig({
  componentId: "sc-67378247-2"
})([
  "",
  ""
], ({ theme: o }) => o.components.footer.linkList), j = /* @__PURE__ */ n.li.withConfig({
  componentId: "sc-67378247-3"
})([
  "",
  ""
], ({ theme: o }) => o.components.footer.linkListItem), L = /* @__PURE__ */ n(h).withConfig({
  componentId: "sc-67378247-4"
})([
  "",
  ""
], ({ theme: o }) => o.components.footer.icon), y = /* @__PURE__ */ n(w).withConfig({
  componentId: "sc-67378247-5"
})([
  "",
  ""
], ({ theme: o }) => o.components.footer.link), q = /* @__PURE__ */ n(I).withConfig({
  componentId: "sc-67378247-6"
})([
  "",
  ""
], ({ theme: o }) => o.components.footer.copyright), F = [
  "light",
  "lightSecondary"
], v = ({ links: o, copyright: a, variant: r = "light", maxWidth: c = g.EIGHT_COLUMN_NO_PADDING, ...m }) => {
  const i = F.includes(r) ? "dark" : "light";
  return /* @__PURE__ */ t.jsx(C, {
    "data-qa-id": "footer",
    variant: r,
    ...m,
    children: /* @__PURE__ */ t.jsxs(x, {
      "data-qa-id": "footer-content",
      maxWidth: c,
      children: [
        /* @__PURE__ */ t.jsx(k, {
          "data-qa-id": "footer-links",
          children: o.map(({ text: e, url: p, ...d }, l) => /* @__PURE__ */ t.jsx(j, {
            children: /* @__PURE__ */ t.jsxs(y, {
              size: "small",
              href: p,
              target: "_blank",
              rel: "noreferrer noopener",
              variant: i,
              "data-qm-allow": !0,
              ...d,
              children: [
                e,
                /* @__PURE__ */ t.jsx(u, {
                  children: "opens in new tab"
                }),
                /* @__PURE__ */ t.jsx(L, {})
              ]
            })
          }, `${l}-${e}`))
        }),
        /* @__PURE__ */ t.jsx(q, {
          "data-qa-id": "footer-copyright",
          size: "small",
          variant: i,
          suppressHydrationWarning: !0,
          "data-qm-allow": !0,
          children: a
        })
      ]
    })
  });
};
export {
  v as default
};
